import { render, staticRenderFns } from "./SNPMB-Materi.vue?vue&type=template&id=5c0db4a0&"
import script from "./SNPMB-Materi.vue?vue&type=script&lang=js&"
export * from "./SNPMB-Materi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports